const triggerSelector = ".u-video__trigger";
const modalSelector = ".video__modal";
const closeSelector = ".video__modal-close";
const iframeSelector = "iframe";

let initialized = false;

export function initVideoModal() {
  if (initialized) return;

  const modal = document.querySelector(modalSelector);
  const triggers = document.querySelectorAll(triggerSelector);

  if (!modal || triggers.length === 0) return;

  initialized = true;
  bindTriggers(modal, triggers);
  bindClose(modal);
}

function bindTriggers(modal, triggers) {
  triggers.forEach(function(trigger) {
    trigger.addEventListener("click", function(event) {
      event.preventDefault();

      const videoUrl = trigger.getAttribute("data-url");

      if (!videoUrl) return;

      openModal(modal, videoUrl);
    });
  });
}

function bindClose(modal) {
  modal.querySelectorAll(closeSelector).forEach(function(closeButton) {
    closeButton.addEventListener("click", function(event) {
      event.preventDefault();
      closeModal(modal);
    });
  });

  document.addEventListener("keydown", function(event) {
    if (event.key === "Escape" && modal.classList.contains("open")) {
      closeModal(modal);
    }
  });
}

function openModal(modal, videoUrl) {
  setVideoUrl(modal, videoUrl);
  modal.classList.add("open");
  modal.setAttribute("aria-hidden", "false");
}

function closeModal(modal) {
  modal.classList.remove("open");
  modal.setAttribute("aria-hidden", "true");
  removeVideoUrl(modal);
}

function setVideoUrl(modal, videoUrl) {
  const iframe = modal.querySelector(iframeSelector);

  if (iframe) {
    iframe.setAttribute("src", videoUrl);
  }
}

function removeVideoUrl(modal) {
  const iframe = modal.querySelector(iframeSelector);

  if (iframe) {
    iframe.removeAttribute("src");
  }
}
